module.exports = __webpack_public_path__ + "img/feature_behavioral_analytics.8a101823.png";